import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { OtpPurpose, OtpSessionService } from '../services/otp-session/otp-session.service';

// Matches backend OTP-protected endpoints. The 'seller/' branch of the shipments
// API is public (no token), so we explicitly skip it.
const PROTECTED_PATTERN =
  /\/starlink\/(shipments|compliance)\/([^/]+)\/(details|tracking|history|delivery-date|address|national-address|submit)(\/|$)/;

export const otpTokenInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(OtpSessionService);
  const router = inject(Router);

  const match = req.url.match(PROTECTED_PATTERN);
  if (!match || req.url.includes('/seller/')) {
    return next(req);
  }

  const [, scope, rawRef] = match;
  const referenceId = decodeURIComponent(rawRef);
  const purpose: OtpPurpose = scope === 'compliance' ? 'ComplianceDocuments' : 'ShipmentTracking';
  const entry = session.get(referenceId, purpose);

  const authReq = entry?.token
    ? req.clone({ setHeaders: { 'X-Otp-Token': entry.token } })
    : req;

  return next(authReq).pipe(
    catchError((err: { status?: number }) => {
      if (err?.status === 401) {
        session.clear(referenceId, purpose);
        const route = purpose === 'ComplianceDocuments' ? 'txc' : 'shipment';
        void router.navigate([`/${route}`, referenceId, 'otp']);
      }
      return throwError(() => err);
    })
  );
};
